// Tableaux de dimensions des produits inox (✓ = disponible)
const inoxTables = {
  "inox-tube-rond": [
    {
      title: "Tubes ronds 316L",
      notes: ["Nuance : 316L (1.4404)", "Norme : ASTM A312", "Utilisation : transport de fluides dans tout type d'industries"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 3 }],
        ["1", "1.6", "2"]
      ],
      rows: [
        ["6", "✓", "", ""],
        ["8", "✓", "", ""],
        ["10", "✓", "", ""],
        ["12", "✓", "", ""],
        ["21.3", "", "✓", ""],
        ["26.9", "", "✓", ""],
        ["33.7", "", "✓", ""],
        ["42.4", "", "", "✓"],
        ["48.3", "", "", "✓"],
        ["60.3", "", "", "✓"],
        ["76.1", "", "", "✓"]
      ]
    },
    {
      title: "Tubes ronds 304L",
      notes: ["Nuance : 304L (1.4307)", "Norme : ASTM A312", "Utilisation : transport de fluides dans tout type d'industries"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 3 }],
        ["1.6", "2", "3.05"]
      ],
      rows: [
        ["21.3", "✓", "", ""],
        ["26.9", "✓", "", ""],
        ["33.7", "", "✓", ""],
        ["42.4", "", "✓", ""],
        ["48.3", "", "✓", ""],
        ["60.3", "", "✓", ""],
        ["76.1", "", "✓", ""],
        ["88.9", "", "", "✓"],
        ["114.3", "", "", "✓"]
      ]
    }
  ],
  "inox-tube-carre": [
    {
      title: "Dimensions disponibles",
      notes: ["Nuance : 304 (1.4301)", "Normes : EN 10305-5, EN 10219-2"],
      header: [
        ["Dimensions (mm)", "Épaisseur (mm)", "Épaisseur (mm)"]
      ],
      rows: [
        ["16X16", "1.0", "1.2"],
        ["20X20", "1.0", "1.2"],
        ["25X25", "1.0", "1.2"],
        ["30X30", "1.0", "1.2"],
        ["35X35", "1.0", "1.2"],
        ["40X40", "1.0", "1.2"],
        ["50X50", "1.5", "2.0"],
        ["60X60", "1.5", "2.0"],
        ["80X80", "", "2.0"],
        ["100X100", "", "2.0"],
        ["120X120", "", "4.0"]
      ]
    }
  ],
  "inox-tube-rectangulaire": [
    {
      title: "Dimensions disponibles",
      notes: ["Nuance : 304 (1.4301)", "Normes : EN 10305-5, EN 10219-2"],
      header: [
        ["Longueur (mm)", "Largeur (mm)", "Épaisseur (mm)"]
      ],
      rows: [
        ["30", "15", "1.0"],
        ["30", "15", "1.2"],
        ["30", "15", "1.5"],
        ["30", "20", "1.2"],
        ["40", "20", "1.2"],
        ["50", "30", "1.5"],
        ["60", "30", "1.5"],
        ["60", "30", "2.0"],
        ["80", "40", "1.5"],
        ["100", "40", "3.0"]
      ]
    }
  ],
  "inox-tube-rond-din": [
    {
      title: "Dimensions disponibles",
      notes: ["304L DIN (1.4307) : EN 10217-7 TC1, DIN 11850", "316L DIN (1.4404) : EN 10217-7 TC1, DIN 11850", "Soudure : laser", "Utilisation : agroalimentaire et boissons (304L DIN), industrie pharmaceutique (316L DIN)"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 2 }],
        ["1.5", "2"]
      ],
      rows: [
        ["28", "✓", ""],
        ["40", "✓", ""],
        ["52", "✓", ""],
        ["70", "", "✓"],
        ["85", "", "✓"],
        ["104", "", "✓"]
      ]
    }
  ],
  "inox-tube-rond-sms": [
    {
      title: "Tubes ronds 304L SMS",
      notes: ["Nuance : 304L SMS (1.4307)", "Normes : EN 10217-7, SMS 3008"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 5 }],
        ["1.2", "1.25", "1.5", "1.6", "2"]
      ],
      rows: [
        ["25.4", "", "✓", "", "", ""],
        ["38.1", "✓", "", "✓", "", ""],
        ["50.8", "✓", "", "", "", ""],
        ["63.5", "", "", "✓", "", ""],
        ["76.1", "", "", "✓", "", ""],
        ["101.6", "", "", "", "✓", "✓"]
      ]
    },
    {
      title: "Tubes ronds 316L SMS",
      notes: ["Nuance : 316L SMS (1.4404)", "Normes : EN 10217-7, SMS 3008"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 4 }],
        ["1.2", "1.5", "1.6", "2"]
      ],
      rows: [
        ["25.4", "✓", "✓", "", ""],
        ["38.1", "✓", "✓", "", ""],
        ["50.8", "✓", "✓", "", ""],
        ["63.5", "", "", "✓", ""],
        ["76.1", "", "", "✓", ""]
      ]
    }
  ],
  "inox-tube-rond-304l-316l": [
    {
      title: "Tubes ronds 304L",
      notes: ["Nuance : 304L (1.4307)", "Normes : EN 10217-7 TC1, ISO 1127 D3-T3", "Soudure laser : transport de fluides dans tout type d'industries", "Soudure HF : construction générale, mécanique et traitement thermique"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 9 }],
        ["0.8", "1", "1.2", "1.5", "1.6", "2", "2.6", "3", "4"]
      ],
      rows: [
        ["10", "", "✓", "", "", "", "", "", "", ""],
        ["12", "", "✓", "", "", "", "", "", "", ""],
        ["14", "", "✓", "", "", "", "", "", "", ""],
        ["16", "", "✓", "", "", "", "", "", "", ""],
        ["18", "✓", "✓", "", "", "", "", "", "", ""],
        ["20", "", "✓", "", "", "", "", "", "", ""],
        ["21.3", "", "", "", "", "✓", "", "", "", ""],
        ["22", "", "✓", "", "", "", "✓", "", "", ""],
        ["25", "", "", "✓", "", "", "", "", "", ""],
        ["26.9", "", "", "", "", "✓", "", "✓", "", ""],
        ["33.7", "", "", "", "", "✓", "", "", "", ""],
        ["40", "", "", "✓", "", "", "", "", "", ""],
        ["42.4", "", "", "", "", "✓", "", "", "", ""],
        ["48.3", "", "", "", "", "✓", "", "", "", ""],
        ["60.3", "", "", "", "", "", "✓", "", "", ""],
        ["76.1", "", "", "", "", "", "✓", "", "", ""],
        ["88.9", "", "", "", "", "", "✓", "", "", ""],
        ["114.3", "", "", "", "", "", "✓", "", "✓", ""],
        ["139.7", "", "", "", "", "", "✓", "", "", ""],
        ["168.3", "", "", "", "", "", "✓", "", "✓", ""],
        ["219.1", "", "", "", "", "", "✓", "", "✓", ""],
        ["273", "", "", "", "", "", "✓", "", "✓", ""],
        ["323.9", "", "", "", "", "", "✓", "", "✓", ""],
        ["406.4", "", "", "", "", "", "", "", "✓", ""],
        ["508", "", "", "", "", "", "", "", "", "✓"]
      ]
    },
    {
      title: "Tubes ronds 316L",
      notes: ["Nuance : 316L (1.4404)", "Normes : EN 10217-7 TC1, ISO 1127 D3-T3", "Soudure laser : transport de fluides dans tout type d'industries"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 3 }],
        ["1", "2", "3"]
      ],
      rows: [
        ["10", "✓", "", ""],
        ["14", "✓", "", ""],
        ["21.3", "", "✓", ""],
        ["26.9", "", "✓", ""],
        ["33.7", "", "✓", ""],
        ["42.4", "", "✓", ""],
        ["48.3", "", "✓", ""],
        ["60.3", "", "✓", ""],
        ["76.1", "", "✓", ""],
        ["88.9", "", "✓", ""],
        ["114.3", "", "✓", "✓"],
        ["139.7", "", "✓", ""],
        ["168.3", "", "✓", ""],
        ["219.1", "", "✓", "✓"],
        ["273", "", "✓", ""],
        ["323.9", "", "", "✓"]
      ]
    }
  ],
  "inox-tube-rond-304l": [
    {
      title: "Dimensions disponibles",
      notes: ["Nuance : 304 (1.4301)", "Normes : EN 10296-2, EN ISO 1127 D3/T3, EN 10305-5, EN 10219-2, ASTM A554", "Soudure : HF", "Utilisation : construction générale, mécanique et traitement thermique"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 4 }],
        ["1", "1.2", "1.5", "2"]
      ],
      rows: [
        ["10", "✓", "", "", ""],
        ["12", "✓", "", "", ""],
        ["14", "✓", "", "", ""],
        ["16", "✓", "", "", ""],
        ["18", "✓", "", "", ""],
        ["20", "✓", "✓", "", ""],
        ["21.3", "", "", "✓", ""],
        ["22", "✓", "✓", "", ""],
        ["25", "", "✓", "", ""],
        ["26.9", "", "", "✓", ""],
        ["30", "", "✓", "", ""],
        ["33.7", "", "", "✓", ""],
        ["40", "", "✓", "✓", ""],
        ["42.4", "", "", "✓", "✓"],
        ["48.3", "", "", "✓", ""],
        ["60.3", "", "", "✓", "✓"],
        ["76.1", "", "", "", "✓"],
        ["88.9", "", "", "", "✓"],
        ["114.3", "", "", "", "✓"]
      ]
    }
  ],
  "inox-tube-schedule": [
    {
      title: "Schedule 10 - 304L et 316L",
      notes: ["Nuances : 304L (1.4307) et 316L (1.4404)", "Norme : ASTM A312", "Utilisation : transport de fluides dans les industries pétrolières, chimiques et gazières"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 5 }],
        ["2.11", "2.77", "3.05", "3.4", "3.76"]
      ],
      rows: [
        ["21.3", "✓", "", "", "", ""],
        ["26.67", "✓", "", "", "", ""],
        ["33.4", "", "✓", "", "", ""],
        ["42.18", "", "✓", "", "", ""],
        ["48.26", "", "✓", "", "", ""],
        ["60.3", "", "✓", "", "", ""],
        ["73.03", "", "", "✓", "", ""],
        ["88.9", "", "", "✓", "", ""],
        ["114.3", "", "", "✓", "", ""],
        ["141.3", "", "", "", "✓", ""],
        ["168.3", "", "", "", "✓", ""],
        ["219.1", "", "", "", "", "✓"]
      ]
    },
    {
      title: "Schedule 40 - 304L et 316L",
      notes: ["Nuances : 304L (1.4307) et 316L (1.4404)", "Norme : ASTM A312", "Utilisation : transport de fluides dans les industries pétrolières, chimiques et gazières"],
      header: [
        [{ label: "Diamètre extérieur (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 9 }],
        ["2.77", "2.87", "3.4", "3.56", "3.7", "3.9", "5.2", "5.5", "6"]
      ],
      rows: [
        ["21.3", "✓", "", "", "", "", "", "", "", ""],
        ["26.67", "", "✓", "", "", "", "", "", "", ""],
        ["33.4", "", "", "✓", "", "", "", "", "", ""],
        ["42.18", "", "", "", "✓", "", "", "", "", ""],
        ["48.26", "", "", "", "", "✓", "", "", "", ""],
        ["60.3", "", "", "", "", "", "✓", "", "", ""],
        ["73.03", "", "", "", "", "", "", "✓", "", ""],
        ["88.9", "", "", "", "", "", "", "", "✓", ""],
        ["114.3", "", "", "", "", "", "", "", "", "✓"]
      ]
    }
  ],
  "inox-raccords-vannerie": [
    {
      title: "Disponibilité par type et par norme",
      notes: ["Normes : AISI, SMS, DIN, Schedule, ASTM", "Nuances : AISI 304L et 316L", "Accessoires : coudes, tés, brides, réductions, colliers, collerettes, vannes, clapets, boulonnerie"],
      header: [
        ["", "304L", "316L", "SMS 304L et 316L", "DIN 304L et 316L", "Schedule 10 304L et 316L", "Schedule 40 304L et 316L"]
      ],
      rows: [
        ["Coude", "✓", "✓", "✓", "✓", "✓", "✓"],
        ["T", "✓", "✓", "✓", "✓", "✓", "✓"],
        ["Bride", "✓", "✓", "", "", "", ""],
        ["Réduction", "✓", "✓", "✓", "✓", "✓", "✓"],
        ["Vanne", "", "✓", "✓", "✓", "", ""]
      ]
    }
  ],
  "inox-tole-alimentaire": [
    {
      title: "Nuances, normes et composition chimique",
      header: [
        ["Norme de fabrication", "Norme américaine", "Norme européenne", "Norme française", "Composition chimique"]
      ],
      rows: [
        ["EN 10088-2, ASTM A240", "304L", "1.4307", "X2CrNi18-10", "C : 0,02% Cr : 17 à 19% Ni : 9 à 11%"],
        ["EN 10088-2, ASTM A240", "316L", "1.4404", "X2CrNiMo12-12", "C : 0,02% Cr : 17 à 19% Ni : 9 à 11% Mo (molybdène) : 2%"]
      ]
    },
    {
      title: "Dimensions disponibles",
      header: [
        ["", { label: "Dimensions (mm)", colSpan: 3 }],
        ["Epaisseurs (mm)", "1000X2000", "1250X2500", "1500X3000"]
      ],
      rows: [
        ["0.4", "✓", "", ""],
        ["0.5", "✓", "", ""],
        ["0.6", "✓", "", ""],
        ["0.8", "✓", "✓", "✓"],
        ["1", "✓", "✓", "✓"],
        ["1.2", "✓", "✓", "✓"],
        ["1.5", "✓", "✓", "✓"],
        ["2", "✓", "✓", "✓"],
        ["2.5", "✓", "✓", "✓"],
        ["3", "✓", "✓", "✓"],
        ["4", "✓", "", "✓"],
        ["5", "✓", "", "✓"],
        ["6", "✓", "", "✓"],
        ["8", "✓", "", "✓"],
        ["10", "✓", "", "✓"],
        ["12", "✓", "", "✓"],
        ["15", "✓", "", "✓"],
        ["20", "✓", "", "✓"]
      ]
    }
  ],
  "inox-tole-larmee": [
    {
      title: "Dimensions disponibles",
      header: [
        ["", { label: "Dimensions (mm)", colSpan: 3 }],
        ["Epaisseurs (mm)", "1000X2000", "1250X2500", "1500X3000"]
      ],
      rows: [
        ["2", "✓", "✓", "✓"],
        ["3", "✓", "✓", "✓"],
        ["4", "✓", "✓", "✓"]
      ]
    }
  ],
  "inox-bobine": [
    {
      title: "Dimensions disponibles",
      header: [
        ["", { label: "Dimensions (mm)", colSpan: 3 }],
        ["Epaisseurs (mm)", "1000", "1250", "1500"]
      ],
      rows: [
        ["0.6", "✓", "✓", "✓"],
        ["0.8", "✓", "✓", "✓"],
        ["1.0", "✓", "✓", "✓"],
        ["1.2", "✓", "✓", "✓"],
        ["1.5", "✓", "✓", "✓"],
        ["2.0", "✓", "✓", "✓"],
        ["2.5", "✓", "✓", "✓"],
        ["3.0", "✓", "✓", "✓"]
      ]
    }
  ],
  "inox-bobine-laminee-chaud": [
    {
      title: "Dimensions disponibles",
      header: [
        ["", { label: "Dimensions (mm)", colSpan: 3 }],
        ["Epaisseurs (mm)", "1000", "1250", "1500"]
      ],
      rows: [
        ["4.0", "✓", "✓", "✓"],
        ["5.0", "✓", "✓", "✓"],
        ["6.0", "✓", "✓", "✓"]
      ]
    }
  ],
  "inox-tole-decorative": [
    {
      title: "Nuance, normes et composition chimique",
      header: [
        ["Norme de fabrication", "Norme américaine", "Norme européenne", "Norme française", "Composition chimique"]
      ],
      rows: [
        ["EN 10028-7, ASTM A240", "430", "1.4016", "X8Cr17", "C : 0,08% Cr : 16-18%"]
      ]
    },
    {
      title: "Dimensions disponibles",
      header: [
        ["Epaisseurs (mm)", "1000X2000"]
      ],
      rows: [
        ["0.4", "✓"],
        ["0.5", "✓"],
        ["0.6", "✓"],
        ["0.8", "✓"],
        ["1", "✓"],
        ["1.2", "✓"],
        ["1.5", "✓"],
        ["2", "✓"]
      ]
    }
  ],
  "inox-rond-plein": [
    {
      title: "Dimensions disponibles",
      notes: ["Normes : ASTM A276 / A470, EN 10088-3, tolérance H9"],
      header: [
        [{ label: "Largeurs (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 6 }],
        ["3", "4", "5", "6", "8", "10"]
      ],
      rows: [
        ["20", "✓", "✓", "✓", "✓", "✓", ""],
        ["30", "✓", "✓", "✓", "✓", "✓", "✓"],
        ["40", "✓", "✓", "✓", "✓", "✓", "✓"],
        ["50", "", "✓", "✓", "✓", "✓", "✓"],
        ["60", "", "✓", "✓", "✓", "✓", "✓"],
        ["70", "", "", "✓", "✓", "✓", "✓"],
        ["80", "", "", "", "", "✓", "✓"],
        ["100", "", "", "", "", "✓", "✓"]
      ]
    }
  ],
  "inox-corniere": [
    {
      title: "Dimensions disponibles",
      notes: ["Nuances : 304 / 304L (1.4301 / 1.4307)"],
      header: [
        [{ label: "Largeurs (mm)", rowSpan: 2 }, { label: "Epaisseurs (mm)", colSpan: 7 }],
        ["3", "4", "5", "6", "7", "8", "10"]
      ],
      rows: [
        ["20X20", "✓", "", "", "", "", "", ""],
        ["25X25", "✓", "", "", "", "", "", ""],
        ["30X30", "✓", "", "", "", "", "", ""],
        ["35X35", "✓", "", "", "", "", "", ""],
        ["40X40", "", "✓", "", "", "", "", ""],
        ["50X50", "", "", "✓", "", "", "", ""],
        ["60X60", "", "", "", "✓", "", "", ""],
        ["70X70", "", "", "", "", "✓", "", ""],
        ["80X80", "", "", "", "", "", "✓", ""],
        ["100X100", "", "", "", "", "", "", "✓"]
      ]
    }
  ]
};

export default inoxTables;
